import React, { Fragment } from "react";

const ProfileModal = ({
  user,
  profile,
  role,
  channelid,
  profile_channelid,
  avatar,
  firstname,
  lastname,
  text,
  image,
  video,
  gif,
  deletePost,
  _id,
  setShowReportUser,
  setReportedUser,
  setShowModal,
  moderators,
  setShowBanUser,
  setBannedUser,
}) => {
  return (
    <Fragment>
      <div className="modal">
        <ul className="modal-items">
          {user.channelid === profile_channelid &&
            user.channelid !== channelid && (
              <li
                onClick={() => {
                  setShowBanUser({
                    submit: true,
                    confirm: false,
                  });
                  setBannedUser({
                    ...setBannedUser,
                    post_id: _id,
                    role,
                    channelid: channelid,
                    avatar: avatar,
                    firstname: firstname,
                    lastname: lastname,
                    text,
                    image,
                    video,
                    gif,
                  });
                  setShowModal(false);
                }}
                className="modal-item"
              >
                <i
                  className={`fa-solid fa-ban mx-5 ${
                    profile && profile.role === "innovator"
                      ? "green"
                      : profile && profile.role === "mentor"
                      ? "red"
                      : profile && profile.role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>
                Ban
              </li>
            )}
          {user && user.channelid !== channelid && (
            <li
              onClick={() => {
                setShowReportUser({ submit: true, confirm: false });
                setReportedUser({
                  role,
                  channelid,
                  avatar,
                  firstname,
                  lastname,
                  text: text !== "" ? text : "",
                  image: image !== "" ? image : "",
                  video: video !== "" ? video : "",
                  gif: gif !== "" ? gif : "",
                });
                setShowModal(false);
              }}
              className="modal-item"
            >
              <i
                className={`fas fa-flag mx-5 ${
                  role && role === "innovator"
                    ? "green"
                    : role && role === "mentor"
                    ? "red"
                    : role && role === "employer"
                    ? "blue"
                    : ""
                }`}
              ></i>
              Report
            </li>
          )}
          {/* {user && user.channelid !== channelid && (
            <li className="modal-item">
              <i
                className={`fas fa-ban mx-5 ${
                  role && role === "innovator"
                    ? "green"
                    : role && role === "mentor"
                    ? "red"
                    : role && role === "employer"
                    ? "blue"
                    : ""
                }`}
              ></i>
              Block
            </li>
          )} */}
          {user && user.channelid === channelid && (
            <li
              className="modal-item"
              onClick={() => {
                deletePost(_id, profile_channelid);
              }}
            >
              <i
                className={`fas fa-times mx-5 ${
                  role && role === "innovator"
                    ? "green"
                    : role && role === "mentor"
                    ? "red"
                    : role && role === "employer"
                    ? "blue"
                    : ""
                }`}
              ></i>
              Delete
            </li>
          )}
          {moderators.map((mod) => {
            if (
              mod.channelid === user.channelid &&
              channelid !== user.channelid
            ) {
              return (
                <li
                  className="modal-item"
                  onClick={() => {
                    deletePost(_id, profile_channelid);
                  }}
                >
                  <i
                    className={`fas fa-times mx-5 ${
                      role && role === "innovator"
                        ? "green"
                        : role && role === "mentor"
                        ? "red"
                        : role && role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>
                  Delete
                </li>
              );
            }
          })}
          {user &&
            user.channelid !== channelid &&
            user.channelid === profile_channelid && (
              <li
                className="modal-item"
                onClick={() => {
                  deletePost(_id, profile_channelid);
                }}
              >
                <i
                  className={`fas fa-times mx-5 ${
                    role && role === "innovator"
                      ? "green"
                      : role && role === "mentor"
                      ? "red"
                      : role && role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>
                Delete
              </li>
            )}
        </ul>
      </div>
    </Fragment>
  );
};

export default ProfileModal;
